import { tokens } from '@cellula/react-theme-patient';
import { motion } from 'framer-motion';
import styled from 'styled-components';

export const StickyTopBannerContent = styled(motion.div)`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 40px;
	background-color: ${tokens.color.bg.surface};
	border-bottom: 1px solid ${tokens.color.border.default};
	padding: ${tokens.spacing.x1_5};
`;
